class CertificadoInexistenteModalController {
    constructor(empresas, scope, modalInstance, $uibModal, pathService) {
        this.scope = scope
        this.modalInstance = modalInstance
        this.empresas = empresas
        this.modal = $uibModal
        this.pathService = pathService
        this.importado = false

        this.timer = 10
        this.runTimer()
    }

    runTimer() {
        setTimeout(() => {
            if (this.timer > 0) {
                this.scope.$apply(() => this.timer -= 1)
                this.runTimer()
            }
        }, 1000)
    }

    enviarCertificado(empresa) {
        let {empresa_id, razao_social, raiz_cnpj} = empresa
        this.modal.open({
            component: 'envioCertificado',
            size: 'md',
            keyboard: 'static',
            resolve: {
                contrato: () => ({id: empresa_id, razaoSocial: razao_social, raizCnpj: raiz_cnpj})
            }
        })
    }

    close() {
        this.modalInstance.dismiss()
    }
}

angular.module("eficienciaFiscalModule")
    .controller("CertificadoInexistenteModalController", ["empresas", "$scope", "$uibModalInstance", '$uibModal', "pathService", CertificadoInexistenteModalController])
